import { Injectable } from "@angular/core";

import { Global } from "../../../app.global";

@Injectable()
export class DecisionsConst {
  public none = {
    id: "none",
    name: "",
  };

  public upheld = {
    id: "upheld",
    name: "uphold PCN",
  };

  public reqInfo = {
    id: "req-info",
    name: "request info",
  };

  public cancel = {
    id: "cancel",
    name: "cancel PCN",
  };

  public bespokeLetter = {
    id: "bespokeLetter",
    name: "bespoke letter",
  };

  constructor(public global: Global) {}
}
